<template>
  <v-card>
  <v-card-title class="d-flex align-center justify-space-between">
      <div>
        <v-icon left>mdi-chart-line</v-icon>
        Quotes Timeline
      </div>
    </v-card-title>
    <v-card-text>
      <div v-if="loading" class="text-center py-8">
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </div>
      <div v-else>
        <apexchart
          type="line"
          height="380"
          :options="chartOptions"
          :series="series"
        />
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import VueApexCharts from "vue3-apexcharts";
import { statisticsService } from "../services";

export default {
  name: "QuotesTimelineApex",
  components: { apexchart: VueApexCharts },
  props: {
    startDate: { type: [String, Date], required: true },
    endDate: { type: [String, Date], required: true },
  },
  data() {
    return {
      loading: true,
      raw: null,
      series: [],
      chartOptions: {
        chart: {
          id: "quotes-timeline",
          type: "line",
          toolbar: { show: false },
          animations: { enabled: true },
        },
        stroke: { curve: "smooth", width: 3 },
        dataLabels: { enabled: false },
        xaxis: { type: "datetime" },
        yaxis: {
          decimalsInFloat: 0,
          labels: { formatter: (val) => Math.round(val) },
        },
        legend: { position: "top" },
        tooltip: { x: { format: "yyyy MMM dd" } },
        colors: [],
      },
    };
  },
  watch: {
    startDate() { this.loadTimelineData(); },
    endDate() { this.loadTimelineData(); },
  },
  methods: {
    async loadTimelineData() {
      this.loading = true;
      try {
        const startYmd = this.toYmd(this.startDate);
        const endYmd = this.toYmd(this.endDate);
        const response = await statisticsService.getQuotesTimeline({
          period: 'custom',
          startIso: startYmd,
          endIso: endYmd
        });
        if (response?.success) {
          this.raw = response.data;
          this.applyData();
        } else if (response?.timeline) {
          // fallback if service returns data directly
          this.raw = response;
          this.applyData();
        } else {
          this.series = [];
        }
      } catch (e) {
        console.error("Failed to load quotes timeline", e);
        this.series = [];
      } finally {
        this.loading = false;
      }
    },
    toYmd(d) {
      const dt = new Date(d);
      const y = dt.getFullYear();
      const m = String(dt.getMonth() + 1).padStart(2, '0');
      const day = String(dt.getDate()).padStart(2, '0');
      return `${y}-${m}-${day}`;
    },
    applyData() {
      if (!this.raw || !this.raw.timeline || !this.raw.channels) {
        this.series = [];
        return;
      }
      const dates = this.raw.timeline.map((d) => new Date(d.date).getTime());
      // Limit to first 3 channels for display as requested
      const topThree = this.raw.channels.slice(0, 3);
      const colors = topThree.map((c) => c.color || "#999999");
      const series = topThree.map((ch) => ({
        name: ch.name,
        data: this.raw.timeline.map((day) => [
          new Date(day.date).getTime(),
          day.channels[ch.id] || 0,
        ]),
      }));
      this.series = series;
      this.chartOptions = {
        ...this.chartOptions,
        colors,
        xaxis: { type: "datetime", categories: dates },
      };
    },
  },
  mounted() {
    this.loadTimelineData();
  },
};
</script>

<style scoped>
.py-8 {
  padding-top: 32px;
  padding-bottom: 32px;
}
</style>
